import { useEffect } from "react";
import JSONTree from "react-json-tree";
import { applicationConnector } from "../../../services/applications/connector";
import { CircularProgress } from "@material-ui/core";

const KreditzReports = ({ kreditzReport, getKreditzReport, params }) => {
  useEffect(() => {
    getKreditzReport(params.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (kreditzReport.fetching) return <CircularProgress />;
  if (kreditzReport.error) return <div>{kreditzReport.error}</div>;
  return <JSONTree data={JSON.parse(kreditzReport.result)} />;
};

export default applicationConnector(KreditzReports);
